<template>
  <div>
    <b-form-select v-model="selected" :options="options"></b-form-select>
  </div>
</template>

<script>

export default {
  name: "odoo-purchase-order-state-select",
  props: {
    value: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: undefined
    },
  },
  data() {
    return {
      selected: this.value || null,
      options: [
        {
          value: null,
          text: this.placeholder ?
              this.placeholder : this.$t('Please select {something}', {something: this.$t('purchase_orders.odoo_purchase_orders.state')})
        },
        {
          value: 'draft',
          text: this.lodash.startCase(this.$t('purchase_orders.odoo_purchase_orders.states.draft')),
        },
        {
          value: 'to approve',
          text: this.lodash.startCase(this.$t('purchase_orders.odoo_purchase_orders.states.to_approve')),
        },
        {
          value: 'purchase',
          text: this.lodash.startCase(this.$t('purchase_orders.odoo_purchase_orders.states.purchase')),
        },
        {
          value: 'done',
          text: this.lodash.startCase(this.$t('purchase_orders.odoo_purchase_orders.states.done')),
        },
        {
          value: 'cancel',
          text: this.lodash.startCase(this.$t('purchase_orders.odoo_purchase_orders.states.cancel')),
        },
      ]
    }
  },
  watch: {
    selected(val, oldVal) {
      if (val !== oldVal) {
        this.$emit('input', val);
      }
    },
    value(val) {
      this.selected = val !== this.selected ? val ?? null : this.selected;
    }
  },
  methods: {
    onInput(event) {
      this.$emit('input', event)
    },
    clearAll() {
      this.$emit('input', undefined)
    }
  }
}
</script>

<style scoped>

</style>
